export default __webpack_public_path__ + "static/NBInternationalPro-Light-14b92155dde8c8b9a503954a81097b9e.woff2";